import React, { useCallback, useState } from 'react';
import { Button } from 'react-bootstrap';
import ContactCreate from './ContactCreate';
import ContactList from './ContactList';
import ContactDetail from './ContactDetail';
import { useUser } from '../../context/UserContext';
import { useTenant } from '../../context/TenantContext';
import { useMembership } from '../../context/MembershipContext';
import { isTenantAdminForTenant } from '../../platform/membershipPermissions';
import ModulePageHeader from '../common/ModulePageHeader';
import useBrowserBackStack from '../../hooks/useBrowserBackStack';
import './Contact.css';

function Contacts() {
  const [selectedContact, setSelectedContact] = useState(null);
  const [showCreateContact, setShowCreateContact] = useState(false);
  const [contactToEdit, setContactToEdit] = useState(null); // State for editing contact

  const { user } = useUser();
  const { tenantId } = useTenant();
  const { memberships } = useMembership();
  const isAdmin = isTenantAdminForTenant(memberships, tenantId, user);

  const handleSelectContact = (contact) => {
    setSelectedContact(contact);
    setShowCreateContact(false);
    setContactToEdit(null); // Clear the edit state when selecting a contact
  };

  const resetToList = useCallback(() => {
    setSelectedContact(null);
    setShowCreateContact(false);
    setContactToEdit(null);
  }, []);

  const onList = !selectedContact && !showCreateContact;
  const closeDetailView = useBrowserBackStack(!onList, resetToList);

  const toggleCreateContactForm = () => {
    if (showCreateContact) {
      closeDetailView();
      return;
    }
    setShowCreateContact(true);
    setSelectedContact(null);
    setContactToEdit(null);
  };

  const handleContactCreated = () => {
    setShowCreateContact(false);
    setSelectedContact(null);
    setContactToEdit(null); // Clear the edit state after creating a contact
  };

  const handleEditContact = (contact) => {
    setContactToEdit(contact); // Set the contact to be edited
    setShowCreateContact(true); // Show the contact create form in edit mode
    setSelectedContact(null);
  };

  const headerTitle = selectedContact?.name || contactToEdit?.name
    || (showCreateContact ? 'Nov kontakt' : 'Kontakti');

  return (
    <div className="platform-module-container contacts-container">
        <ModulePageHeader
          eyebrow={!onList ? 'Kontakti' : undefined}
          title={headerTitle}
          subtitle={onList ? 'Kontaktne osebe in informacije.' : undefined}
          actions={(
            <>
              {!selectedContact && isAdmin && (
                <Button variant="primary" onClick={toggleCreateContactForm}>
                  {showCreateContact ? 'Nazaj' : 'Dodaj kontakt'}
                </Button>
              )}
              {selectedContact && (
                <Button variant="primary" onClick={closeDetailView}>Nazaj na izbiro</Button>
              )}
            </>
          )}
        />
        {!selectedContact ? (
          <>
            {showCreateContact ? (
              <ContactCreate onContactCreated={handleContactCreated} contactToEdit={contactToEdit} />
            ) : (
              <ContactList
                onSelectContact={handleSelectContact}
                isAdmin={isAdmin}
                onEditContact={handleEditContact} // Pass the edit handler to the list
              />
            )}
          </>
        ) : (
          <ContactDetail contact={selectedContact} />
        )}
    </div>
  );
}

export default Contacts;
